export default "__VITE_ASSET__Cbz0_pnE__"